import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../app/store';
import { showErrorMessage } from '../components/message-boxes/ErrorMessage';

export type TpExternalDataType = 'publicationAbstract';

export enum EXTERNAL_DATA_STATUS {
  PENDING = 'pending',
  COMPLETE = 'complete',
  FAILED = 'failed',
}

export interface TpExternalDataResult {
  dataType: TpExternalDataType;
  query: any;
  status: EXTERNAL_DATA_STATUS;
  content: any;
}

export interface TpExternalData {
  requests: { [requestId: string]: TpExternalDataResult };
}

const initialState: TpExternalData = {
  requests: {},
};

export function getExternalDataRequestId(dataType: TpExternalDataType, query: any): string {
  return JSON.stringify({ dataType, query });
}

export const externalDataSlice = createSlice({
  name: 'externalData',
  initialState,
  reducers: {
    addRequest: (state, action: PayloadAction<{ request: TpExternalDataResult }>) => {
      const request = action.payload.request;
      const requestId = getExternalDataRequestId(request.dataType, request.query);
      state.requests[requestId] = request;
    },

    setRequestContent: (state, action: PayloadAction<{ requestId: string; content: any }>) => {
      const requestId = action.payload.requestId;
      const request = state.requests[requestId];
      if (request) {
        request.content = action.payload.content;
        request.status = EXTERNAL_DATA_STATUS.COMPLETE;
      } else {
        showErrorMessage(`Request with ID ${requestId} not found.`);
      }
    },
  },
});

export const { addRequest, setRequestContent } = externalDataSlice.actions;

export const selectExternalData = (state: RootState) => state.externalData;

export default externalDataSlice.reducer;
